import styled from 'styled-components'
import { Box, BoxProps } from '@careguide/theme'
import css from '@styled-system/css'
import { breakpointSizes } from '@careguide/theme'

export type StickyContainerProps = {
  $isSticky: boolean
}

export const Container = styled(Box)`
  display: flex;
  max-width: 896px;
  margin: 0 auto;
  ${css({ pt: 4, pr: 4, pl: 4 })}

  @media (min-width: 896px) {
    ${css({ pr: 0, pl: 0 })}
  }
`

export const TabletAndUpOnlyAdContainer = styled(Container)`
  @media (max-width: ${breakpointSizes.tablet - 1}px) {
    display: none;
  }
`
export const TabletAndUpOnlyBox = styled(Box)`
  @media (max-width: ${breakpointSizes.tablet - 1}px) {
    display: none;
  }
`
export const MobileOnlyBox = styled(Box)`
  @media (min-width: ${breakpointSizes.tablet}px) {
    display: none;
  }
`

export const ResumeLink = styled.a`
  text-decoration: underline;
  ${css({
    fontWeight: 'regular',
    fontSize: 1,
    color: 'gray.6',
  })}
  &:hover {
    ${css({
      color: 'primary.800',
    })}
  }
`

export const StickyContainer = styled(Box)<StickyContainerProps & BoxProps>`
  ${(props) =>
    props.$isSticky
      ? {
          position: 'sticky',
          top: '90px',
        }
      : {}}
`
export const CTAContainer = styled(Box).attrs({ as: 'span' })`
  ${css({
    display: 'block',
  })}
`
